import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import MainPage from './pages/MainPage';
import About from './pages/About';
import Services from './pages/Services';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Appointment from './pages/Appointment';
import Admin from './pages/Admin';
import { AppointmentProvider } from './context/AppointmentContext';
import './styles/appointment.css';

// ── Error Boundary ────────────────────────────────────────────────────────────────────
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('App Error Boundary caught:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          background: '#f8f9ff', color: '#1b126c', fontFamily: 'sans-serif',
          padding: '2rem', textAlign: 'center',
        }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Something went wrong</h2>
          <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>
            Please refresh the page. If the problem persists, try again in a few minutes.
          </p>
          <button
            onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
            style={{
              background: '#1b126c', color: '#fff', border: 'none',
              borderRadius: '10px', padding: '0.75rem 1.75rem',
              fontSize: '1rem', cursor: 'pointer',
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  React.useEffect(() => {
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }, []);

  return (
    <ErrorBoundary>
      <AppointmentProvider>
        <Router>
          <Routes>
            {/* Admin route — completely standalone, no website sidebar/layout */}
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/*" element={<Admin />} />

            {/* All public routes — wrapped in website Layout */}
            <Route
              path="/*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<MainPage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/appointment" element={<Appointment />} />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </Router>
      </AppointmentProvider>
    </ErrorBoundary>
  );
}

export default App;
